import React from 'react';

interface IProps {
  title: string;
  img: string;
  content: string;
}

export class ServiceItem extends React.Component<IProps> {
  render() {
    return (
      <div className="col-md-4 service-item">
        <div className="popup-wrapper">
          <div className="popup-gallery">
            <img src={this.props.img} alt="img" className="width-100" />
          </div>
        </div>
        <div className="service-inner">
          <h3>{this.props.title}</h3>
          <p>{this.props.content}</p>
        </div>
      </div>
    );
  }
}
